import React, { FC, useContext } from 'react';
import { initialize, TeamSummary } from '../../util/tracking.util';
import { fattqueryapi } from '../../api/fattquery';
import { useAsyncEffect, usePrevious } from '../../hooks';
import { AuthStore } from '../../context';

export const Tracker: FC<{ children?: React.ReactNode }> = props => {
  const {
    state: { auth: nextAuth, status: authStatus },
  } = useContext(AuthStore);
  const prevAuth = usePrevious(nextAuth);

  useAsyncEffect(async () => {
    const nextMerchantId = nextAuth?.merchant?.id;
    const prevMerchantId = prevAuth?.merchant?.id;
    const shouldInitializeTracker =
      authStatus === 'authed.fresh' &&
      nextAuth &&
      (!prevAuth || nextMerchantId !== prevMerchantId);

    if (shouldInitializeTracker) {
      const user = nextAuth?.user;
      const merchant = nextAuth?.merchant;
      const authToken = nextAuth?.token;

      if (user && merchant) {
        try {
          const teamSummary: TeamSummary = await fattqueryapi.get(
            authToken,
            '/statistics/teamSummary',
          );
          initialize(user, merchant, teamSummary);
        } catch (error) {
          console.error(error);
        }
      }
    }
  }, [nextAuth, prevAuth]);

  return <>{props.children}</>;
};
